<template>
	<!-- 销售数据页面 -->
	<div>
		<!-- 导航条 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<span class="iconfont" style="float: left;font-size: 14px;margin-right: 10px;">&#xe603;</span>
			<el-breadcrumb-item :to="{ path: '/order/promote22232' }">账户</el-breadcrumb-item>
			<el-breadcrumb-item class="a">付款单</el-breadcrumb-item>
		</el-breadcrumb>
		
		<el-card style="margin-bottom: 20px; margin-top: 5px;">
			<el-tabs v-model="activeName" type="card" @tab-click="handleClick" >
				<el-tab-pane label="普通付款单" name="pt" v-loading="loading">
					<div class="order-time" >
						<span>单据状态：</span>
						<el-select size="mini" v-model="value" placeholder="请选择" @change="StateSelect">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
						<span>付款时间：</span>
						<div class="elbutton">
							<div class="block">
								<el-date-picker size="mini" @change="select" value-format="yyyy-MM-dd" v-model="value1" type="daterange"
								 range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期">
								</el-date-picker>
							</div>
							<div>
								<el-button size="mini" type="primary" @click="exportExcel" style="float: right;margin-left: 10px;">导出</el-button>
								<el-button size="mini" type="success" @click="panduan" style="float: right;margin-left: 10px;">添加</el-button>
								<el-button size="mini"  @click="getList" style="float: right;margin-left: 10px;">查询</el-button>
							</div>
						</div>
					
					</div>
					<div>
						<el-table :height="TableHeight" size="mini" id="outTable" :data="tableData" style="width: 100%;margin-top: 10px;" v-loading="loading"
						 sidx="F_CreateDate" sord="desc" @row-dblclick="dbSelected" :header-cell-style="{background:'#5a8642',color:'#ffffff',padding:'0'}">
							<el-table-column type="index" :index="indexMethod">
							</el-table-column>
							<el-table-column prop="BillsNumber" label="付款单号" width="110px" align="center">
							</el-table-column>
							<!-- <el-table-column prop="cVouchID" label="收款单号" width="150px">
							</el-table-column> -->
							<el-table-column prop="ccusname" label="付款单位" width="120px" align="center">
							</el-table-column>
							<el-table-column prop="fkdate" label="付款时间" width="100px" align="center">
							</el-table-column>
							<el-table-column prop="summoney" label="付款金额" width="120px" align="right">
							</el-table-column>
							<el-table-column prop="StepType" label="单据状态" width="100px" align="center">
							</el-table-column>
							<el-table-column prop="tijiaodate" label="提交时间" width="165px" align="center">
							</el-table-column>
							<el-table-column prop="shenhedate" label="审核时间" width="165px" align="center">
							</el-table-column>
							<el-table-column prop="ckmaker" label="审核人" width="150px" align="center">
							</el-table-column>
							<el-table-column prop="Remarks" label="回退理由" width="230px" align="center">
							</el-table-column>
							<el-table-column prop="Cdate" label="编制时间" width="165px" align="center">
							</el-table-column>
							<el-table-column prop="UserName" label="编制人" width="100px" align="center">
							</el-table-column>
							<el-table-column fixed="right" label="操作" minWidth="150">
								<template slot-scope="scope">
									<el-button @click="look(scope.row)" type="text" size="small">查看</el-button>
									<!--							<el-button @click="compile(scope.row)" type="text" size="small">编辑</el-button>-->
									<el-button @click="deleterow(scope.row)" type="text" size="small">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<!-- 表格 -->
					
					<!-- 表格 -->
					<!--添加弹窗-->
					<el-dialog title="付款单" :visible.sync="addDialog" width="70%" :before-close="Closefalse" :show-close="false" >
						<el-form ref="ruleFormName" style="margin-top: 0px;" status-icon label-width="100px" class="demo-ruleForm" size="mini"
						 :disabled="disabled">
							<el-row>
								<el-col :span="6">
									<el-form-item label="付款单号" prop="Ccode">
										<el-input v-model="ruleForm.add.Ccode" :readonly="true"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="6">
									<el-form-item label="单据状态" prop="Cbuff">
										<el-input v-model="ruleForm.add.Cbuff" :readonly="true"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="6">
									<el-form-item label="操作类型" prop="Ccaozuotype">
										<el-input v-model.number="ruleForm.add.Ccaozuotype" :readonly="true"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="6">
									<el-form-item label="收款单号" prop="txtfapiao">
										<el-input v-model.number="ruleForm.add.txtfapiao" :readonly="true"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="6">
									<el-form-item label="付款单位" prop="Cvname">
										<el-input v-model="ruleForm.add.Cvname" :readonly="true"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="6">
									<el-form-item label="结算科目" prop="txtkemu">
										<el-input v-model="ruleForm.add.txtkemu" :readonly="true"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="6">
									<el-form-item label="付款日期" prop="Cdata">
										<!--                <el-input v-model.number="ruleForm.age"></el-input>-->
										<el-date-picker v-model="ruleForm.Cdata" style="width:100%" type="date" :readonly="true" value-format="yyyy-MM-dd" />
									</el-form-item>
								</el-col>
								<el-col :span="6">
									<el-form-item label="备注" prop="txtbeizhu">
										<el-input v-model.number="ruleForm.add.txtbeizhu"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
							<!--          diago表格-->
							<el-button type="success" icon="el-icon-plus" size="mini" @click="handleAddDetails">添加</el-button>
							<el-table :data="ruleForm.add2" :row-class-name="rowClassName">
								<el-table-column prop="yongtu" label="用途" width="180" show-overflow-tooltip>
									<template slot-scope="scope">
										<el-input v-model="ruleForm.add2[scope.row.xh-1].yongtu"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="money" label="金额" width="180">
									<template slot-scope="scope">
										<el-input v-model="ruleForm.add2[scope.row.xh-1].money"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="bank" label="开户银行" width="180">
									<template slot-scope="scope">
										<!--                <el-input v-model="ruleForm.add2[scope.row.xh-1].bank">
					      <el-button  slot="suffix"  type="text" @click="back">选择</el-button>
					    </el-input>-->
										<el-select v-model="ruleForm.add2[scope.row.xh-1].bank" @change="back(scope.row)">
											<el-option v-for="item in options2" :key="item.autoid" :label="item.bank" :value="item.bank">
											</el-option>
										</el-select>
									</template>
								</el-table-column>
								<el-table-column prop="huming" label="户名" width="200">
									<template slot-scope="scope">
										<el-input v-model="ruleForm.add2[scope.row.xh-1].huming" :readonly="true"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="zhanghao" label="打款账号" width="220">
									<template slot-scope="scope">
										<el-input v-model="scope.row.zhanghao" :readonly="true"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="fujian" label="附件" width="180">
									<template slot-scope="scope">
										<el-input v-model="ruleForm.add2[scope.row.xh-1].fujian"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="type" label="操作" width="180">
									<template slot-scope="scope">
										<el-button @click="handleDeleteDetails(scope.row,scope.row.$index)"> 删除</el-button>
									</template>
								</el-table-column>
							</el-table>
							<el-row style="margin-top: 10px">
								<el-col :span="6">
									<el-form-item label="账户余额" prop="txtzhanghumoney">
										<el-input v-model="ruleForm.add.txtzhanghumoney" :readonly="true"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="6">
									<el-form-item label="制单人" prop="Cvname">
										<el-input v-model="ruleForm.add.Cvname" :readonly="true"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="6">
									<el-form-item label="制单日期" prop="Cdata">
										<!--                <el-input v-model.number="ruleForm.age"></el-input>-->
										<el-date-picker v-model="ruleForm.Cdata" style="width:100%" type="date" :readonly="true" value-format="yyyy-MM-dd" />
									</el-form-item>
								</el-col>
								<el-col :span="6">
									<el-form-item label="合计单据金额" prop="Summoney">
										<el-input v-model.number="ruleForm.add.Summoney"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
					
						</el-form>
						<span slot="footer" class="dialog-footer">
							<el-button size="mini" type="success" @click="submitForm" v-if="ruleForm.add.Cbuff=='未保存！'||ruleForm.add.Cbuff=='已保存'&&ruleForm.add.Ccaozuotype=='编辑'">保存</el-button>
							<el-button size="mini" type="primary" @click="submitForm2" v-if="ruleForm.add.Cbuff=='已保存'&&ruleForm.add.Ccaozuotype=='查看'">提交</el-button>
							<el-button size="mini" type="primary" @click="revocation" v-if="ruleForm.add.Cbuff=='已提交'">撤销</el-button>
							<el-button size="mini" type="primary" @click="xiugai" v-if="ruleForm.add.Cbuff=='已保存'&&ruleForm.add.Ccaozuotype=='查看'">修改</el-button>
							<el-button size="mini" type="danger" @click="quxiao" v-if="ruleForm.add.Ccaozuotype=='编辑'">取消</el-button>
							<el-button size="mini" type="primary" @click="addDialog = false">关 闭</el-button>
						</span>
					</el-dialog>
					
					<!-- 分页区域 -->
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page"
					 :page-sizes="[10,50,100,500]" :page-size="pagination.rows" layout="total, sizes, prev, pager, next, jumper" :total="pagination.records">
					</el-pagination>
				</el-tab-pane>
				<el-tab-pane :label="hdname" name="hd" v-if="ishdplan" v-loading="loading">
					<div class="order-time" >
						<span>单据状态：</span>
						<el-select size="mini" v-model="hdvalue" placeholder="请选择" @change="hdStateSelect">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
						<span>付款时间：</span>
						<div class="elbutton">
							<div class="block">
								<el-date-picker size="mini" @change="hdselect" value-format="yyyy-MM-dd" v-model="hdvalue1" type="daterange"
								 range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期">
								</el-date-picker>
							</div>
							<div>
								<el-button size="mini" type="primary" @click="hdexportExcel" style="float: right;margin-left: 10px;">导出</el-button>
								<el-button size="mini" type="success" @click="hdadd" style="float: right;margin-left: 10px;">添加活动付款单</el-button>
								<el-button size="mini"  @click="hdgetList" style="float: right;margin-left: 10px;">查询</el-button>
							</div>
						</div>
					
					</div>
					<div>
						<el-table :height="TableHeight" size="mini" id="hdoutTable" :data="hdtableData" style="width: 100%;margin-top: 10px;" v-loading="hdloading"
						 sidx="F_CreateDate" sord="desc" @row-dblclick="hddbSelected">
							<el-table-column type="index" :index="hdindexMethod">
							</el-table-column>
							<el-table-column prop="BillsNumber" label="付款单号" width="110px" align="center">
							</el-table-column>
							<!-- <el-table-column prop="cVouchID" label="收款单号" width="150px">
							</el-table-column> -->
							<el-table-column prop="ccusname" label="付款单位" width="120px" align="center">
							</el-table-column>
							<el-table-column prop="fkdate" label="付款时间" width="100px" align="center">
							</el-table-column>
							<el-table-column prop="summoney" label="付款金额" width="120px" align="right">
							</el-table-column>
							<el-table-column prop="StepType" label="单据状态" width="100px" align="center">
							</el-table-column>
							<el-table-column prop="tijiaodate" label="提交时间" width="165px" align="center">
							</el-table-column>
							<el-table-column prop="shenhedate" label="审核时间" width="165px" align="center">
							</el-table-column>
							<el-table-column prop="ckmaker" label="审核人" width="150px" align="center">
							</el-table-column>
							<el-table-column prop="Remarks" label="回退理由" width="230px" align="center">
							</el-table-column>
							<el-table-column prop="Cdate" label="编制时间" width="165px" align="center">
							</el-table-column>
							<el-table-column prop="UserName" label="编制人" width="100px" align="center">
							</el-table-column>
							<el-table-column fixed="right" label="操作" minWidth="150">
								<template slot-scope="scope">
									<el-button @click="hdlook(scope.row)" type="text" size="small">查看</el-button>
									<!--							<el-button @click="compile(scope.row)" type="text" size="small">编辑</el-button>-->
									<el-button @click="hddeleterow(scope.row)" type="text" size="small">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<!-- 表格 -->
					
					<!-- 表格 -->
					<!--添加弹窗-->
					<el-dialog title="活动付款单" :visible.sync="hdaddDialog" width="70%" :before-close="Closefalse" :show-close="false" >
						<el-form ref="hdruleFormName" style="margin-top: 0px;" status-icon label-width="100px" class="demo-ruleForm" size="mini"
						 :disabled="disabled">
							<el-row>
								<el-col :span="6">
									<el-form-item label="付款单号" prop="Ccode">
										<el-input v-model="hdruleForm.add.Ccode" :readonly="true"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="6">
									<el-form-item label="单据状态" prop="Cbuff">
										<el-input v-model="hdruleForm.add.Cbuff" :readonly="true"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="6">
									<el-form-item label="操作类型" prop="Ccaozuotype">
										<el-input v-model.number="hdruleForm.add.Ccaozuotype" :readonly="true"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="6">
									<el-form-item label="收款单号" prop="txtfapiao">
										<el-input v-model.number="hdruleForm.add.txtfapiao" :readonly="true"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="6">
									<el-form-item label="付款单位" prop="Cvname">
										<el-input v-model="hdruleForm.add.Cvname" :readonly="true"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="6">
									<el-form-item label="结算科目" prop="txtkemu">
										<el-input v-model="hdruleForm.add.txtkemu" :readonly="true"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="6">
									<el-form-item label="付款日期" prop="Cdata">
										<!--                <el-input v-model.number="ruleForm.age"></el-input>-->
										<el-date-picker v-model="hdruleForm.Cdata" style="width:100%" type="date" :readonly="true" value-format="yyyy-MM-dd" />
									</el-form-item>
								</el-col>
								<el-col :span="6">
									<el-form-item label="备注" prop="txtbeizhu">
										<el-input v-model.number="hdruleForm.add.txtbeizhu"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
							<!--          diago表格-->
							<el-button type="success" icon="el-icon-plus" size="mini" @click="hdhandleAddDetails">添加</el-button>
							<el-table :data="hdruleForm.add2" :row-class-name="hdrowClassName">
								<el-table-column prop="yongtu" label="用途" width="180" show-overflow-tooltip>
									<template slot-scope="scope">
										<el-input v-model="hdruleForm.add2[scope.row.xh-1].yongtu"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="money" label="金额" width="180">
									<template slot-scope="scope">
										<el-input v-model="hdruleForm.add2[scope.row.xh-1].money"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="bank" label="开户银行" width="180">
									<template slot-scope="scope">
										<!--                <el-input v-model="ruleForm.add2[scope.row.xh-1].bank">
					      <el-button  slot="suffix"  type="text" @click="back">选择</el-button>
					    </el-input>-->
										<el-select v-model="hdruleForm.add2[scope.row.xh-1].bank" @change="hdback(scope.row)">
											<el-option v-for="item in hdoptions2" :key="item.autoid" :label="item.bank" :value="item.bank">
											</el-option>
										</el-select>
									</template>
								</el-table-column>
								<el-table-column prop="huming" label="户名" width="200">
									<template slot-scope="scope">
										<el-input v-model="hdruleForm.add2[scope.row.xh-1].huming" :readonly="true"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="zhanghao" label="打款账号" width="220">
									<template slot-scope="scope">
										<el-input v-model="scope.row.zhanghao" :readonly="true"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="fujian" label="附件" width="180">
									<template slot-scope="scope">
										<el-input v-model="hdruleForm.add2[scope.row.xh-1].fujian"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="type" label="操作" width="180">
									<template slot-scope="scope">
										<el-button @click="hdhandleDeleteDetails(scope.row,scope.row.$index)"> 删除</el-button>
									</template>
								</el-table-column>
							</el-table>
							<el-row style="margin-top: 10px">
								<el-col :span="6">
									<el-form-item label="账户余额" prop="txtzhanghumoney">
										<el-input v-model="hdruleForm.add.txtzhanghumoney" :readonly="true"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="6">
									<el-form-item label="制单人" prop="Cvname">
										<el-input v-model="hdruleForm.add.Cvname" :readonly="true"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="6">
									<el-form-item label="制单日期" prop="Cdata">
										<!--                <el-input v-model.number="ruleForm.age"></el-input>-->
										<el-date-picker v-model="hdruleForm.Cdata" style="width:100%" type="date" :readonly="true" value-format="yyyy-MM-dd" />
									</el-form-item>
								</el-col>
								<el-col :span="6">
									<el-form-item label="合计单据金额" prop="Summoney">
										<el-input v-model.number="hdruleForm.add.Summoney"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
					
						</el-form>
						<span slot="footer" class="dialog-footer">
							<el-button size="mini" type="success" @click="hdsubmitForm" v-if="hdruleForm.add.Cbuff=='未保存！'||hdruleForm.add.Cbuff=='已保存'&&hdruleForm.add.Ccaozuotype=='编辑'">保存</el-button>
							<el-button size="mini" type="primary" @click="hdsubmitForm2" v-if="hdruleForm.add.Cbuff=='已保存'&&hdruleForm.add.Ccaozuotype=='查看'">提交</el-button>
							<el-button size="mini" type="primary" @click="hdrevocation" v-if="hdruleForm.add.Cbuff=='已提交'">撤销</el-button>
							<el-button size="mini" type="primary" @click="hdxiugai" v-if="hdruleForm.add.Cbuff=='已保存'&&hdruleForm.add.Ccaozuotype=='查看'">修改</el-button>
							<el-button size="mini" type="danger" @click="hdquxiao" v-if="hdruleForm.add.Ccaozuotype=='编辑'">取消</el-button>
							<el-button size="mini" type="primary" @click="hdaddDialog = false">关 闭</el-button>
						</span>
					</el-dialog>
					
					<!-- 分页区域 -->
					<el-pagination @size-change="hdhandleSizeChange" @current-change="hdhandleCurrentChange" :current-page="hdpagination.page"
					 :page-sizes="[10,50,100,500]" :page-size="hdpagination.rows" layout="total, sizes, prev, pager, next, jumper" :total="hdpagination.records">
					</el-pagination>
					
				</el-tab-pane>
			</el-tabs>
			
			
			
		</el-card>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import FileSaver from 'file-saver'
	import XLSX from 'xlsx'

	export default {
		data() {
			return {
				hdname:"活动付款单",
				ishdplan:true,
				activeName:"pt",
				loading: true,
				hdloading: true,
				value1: '',
				hdvalue1: '',
				radio1: '全部',
				hdradio1: '全部',
				tableData: [],
				hdtableData: [],
				pagination: {
					//默认每页显示的条数
					rows: 10,
					//默认显示第一页
					page: 1,
					//总数据条数
					records: 10,
					//总页数
					total: 5,
					sidx: "F_CreateDate",
					sord: "desc"
				},
				hdpagination: {
					//默认每页显示的条数
					rows: 10,
					//默认显示第一页
					page: 1,
					//总数据条数
					records: 10,
					//总页数
					total: 5,
					sidx: "F_CreateDate",
					sord: "desc"
				},
				keyValue: '',
				hdkeyValue: '',
				z: [],
				hdz: [],
				//全部
				keyword: {
					//keyword:this.$store.state.user.F_CustomerName,
					F_Invalid: '',
					F_FlowCode: '',
					// StartDate: '2020-07-15T16:00:00.000Z',
					// EndDate: '2020-07-17T16:00:00.000Z'
					StartDate: '',
					EndDate: ''
				},
				hdkeyword: {
					//keyword:this.$store.state.user.F_CustomerName,
					F_Invalid: '',
					F_FlowCode: '',
					// StartDate: '2020-07-15T16:00:00.000Z',
					// EndDate: '2020-07-17T16:00:00.000Z'
					StartDate: '',
					EndDate: ''
				},
				queryJson: {
					begindate: "",
					enddate: "",
					Remarks: "",
					BillsNumber: "",
					StepType: ""
				},
				hdqueryJson: {
					begindate: "",
					enddate: "",
					Remarks: "",
					BillsNumber: "",
					StepType: ""
				},
				StartDate: '',
				hdStartDate: '',
				EndDate: '',
				hdEndDate: '',
				SearchForm: [],
				hdSearchForm: [],
				records: '',
				hdrecords: '',
				orderAmount: [],
				hdorderAmount: [],
				addDialog: false,
				hdaddDialog: false,
				ruleForm: {
					Cdata: '',
					add: [],
					add2: [],
				},
				hdruleForm: {
					Cdata: '',
					add: [],
					add2: [],
				},
				options: [{
						value: '',
						label: '全部'
					},
					{
						value: '已保存',
						label: '已保存'
					},
					{
						value: '已提交',
						label: '已提交'
					},
					{
						value: '已审核',
						label: '已审核'
					},
					{
						value: '已退回',
						label: '已退回'
					},
				],
				options2: [],
				hdoptions2: [],
				value: '',
				hdvalue: '',
				addback: [],
				hdaddback: [],
				danjuhao: '',
				hddanjuhao: '',
				disabled: false,
				TableHeight:400,
				ishd:true,
			}


		},
		created() {
			this.getList(this.keyword)
			this.gethdplan()
			this.TableHeight=(document.documentElement.clientHeight-240)+"px"
		},
		methods: {
			//是否存在活动
			gethdplan(){
				request({
					url: '/DRPORDERAPI.ashx?a=gethdplan',
					method: 'post',
					data: {
					}
				}).then(res => {
					if(res.code==200){
						this.ishdplan=true
						this.ishd=true
						this.hdname+="("+res.data+")"
					}else{
						this.ishdplan=false
						this.ishd=false
						/*this.$message({
							message:res.info,
							type:"error"
						})*/
					}
				})
			},
			//tab切换
			handleClick(tab, event) {
				if (tab.name == "pt") {
					this.getList(this.keyword)
				} else if (tab.name == "hd" ) {
					this.hdgetList(this.hdkeyword)
				}
			},
			//不准关闭
			Closefalse(){
				return false
			},
			//双击表格事件
			dbSelected(row) {
				this.look(row);
			},
			hddbSelected(row) {
				this.hdlook(row);
			},
			//撤销付款单
			revocation() {
				request({
					url: '/DRPAPI.ashx?a=getfukuanrevocation',
					method: 'post',
					data: {
						User: this.$store.state.user.F_CustomerId,
						Danjuhao: this.danjuhao,
					}
				}).then(res => {
					this.$message({
						message: '撤销成功',
						type: 'success'
					});
					this.ruleForm.add.Cbuff = '已保存 ';
					/* this.disabled=false;*/
					this.getList();
					this.addDialog = false
				})
			},
			hdrevocation() {
				request({
					url: '/DRPAPI.ashx?a=gethdfukuanrevocation',
					method: 'post',
					data: {
						User: this.$store.state.user.F_CustomerId,
						Danjuhao: this.hddanjuhao,
					}
				}).then(res => {
					this.$message({
						message: '撤销成功',
						type: 'success'
					});
					this.hdruleForm.add.Cbuff = '已保存 ';
					/* this.disabled=false;*/
					this.hdgetList();
					this.hdaddDialog = false
				})
			},
			//提交付款单
			submitForm2() {

				request({
					url: '/DRPAPI.ashx?a=getfukuansubmit',
					method: 'post',
					data: {
						User: this.$store.state.user.F_CustomerId,
						Danjuhao: this.danjuhao,
					}
				}).then(res => {
					this.$message({
						message: '提交成功',
						type: 'success'
					});
					this.ruleForm.add.Cbuff = '已提交';
					/*  this.disabled=true;*/
					this.getList();
					this.addDialog = false
				})
			},
			hdsubmitForm2() {

				request({
					url: '/DRPAPI.ashx?a=gethdfukuansubmit',
					method: 'post',
					data: {
						User: this.$store.state.user.F_CustomerId,
						Danjuhao: this.hddanjuhao,
					}
				}).then(res => {
					this.$message({
						message: '提交成功',
						type: 'success'
					});
					this.hdruleForm.add.Cbuff = '已提交';
					/*  this.disabled=true;*/
					this.hdgetList();
					this.hdaddDialog = false
				})
			},
			//addDialog保存付款单
			submitForm(formName) {
				var hasmoney = 0,
					hasbank = 0,
					haszhanghao = 0
					console.log(this.danjuhao)
				for (var i = 0; i < this.ruleForm.add2.length; i++) {
					if (this.ruleForm.add2[i].zhanghao == "") {
						haszhanghao = 1
					}
					if (this.ruleForm.add2[i].money == "") {
						hasmoney = 1
					}
					if (this.ruleForm.add2[i].bank == "") {
						hasbank = 1
					}
					//delete this.ruleForm.add2[i].xh
				}
				if (hasbank == 1) {
					this.$message({
						message: '请选择开户银行',
						type: 'error'
					});
					return
				}
				if (hasmoney == 1) {
					this.$message({
						message: '请填写金额',
						type: 'error'
					});
					return
				}
				if (haszhanghao == 1) {
					this.$message({
						message: '请填写打款账号',
						type: 'error'
					});
					return
				}
				if (this.ruleForm.add2.length == 0) {
					this.$message({
						message: '请至少填写一行付款单',
						type: 'error'
					});
					return
				}
				if (!!this.danjuhao) {
					request({
						url: '/DRPAPI.ashx?a=getfukuanbjsave',
						method: 'post',
						contentType: "application/json; charset=utf-8",
						dataType: "json",
						data: {
							q: JSON.stringify({
								beizhu: this.ruleForm.add.txtbeizhu,
								Ddata: this.ruleForm.add2,
								User: this.$store.state.user.F_CustomerId,
								kemu: this.ruleForm.add.txtkemu,
								danjuhao: this.danjuhao,

							})
						}
					}).then(res => {
						this.$message({
							message: '保存成功',
							type: 'success'
						});
						this.getList();
						//this.ruleForm.add2 = []
						//this.addDialog = false
					})
				} else {
					request({
						url: '/DRPAPI.ashx?a=getfukuansave',
						method: 'post',
						contentType: "application/json; charset=utf-8",
						dataType: "json",
						data: {
							q: JSON.stringify({
								beizhu: this.ruleForm.add.txtbeizhu,
								Ddata: this.ruleForm.add2,
								User: this.$store.state.user.F_CustomerId,
								kemu: this.ruleForm.add.txtkemu,

							})
						}
					}).then(res => {
						this.$message({
							message: '保存成功',
							type: 'success'
						});
						this.getList();
						//this.ruleForm.add2 = []
						this.addDialog = false
					})
				}

				/*this.$refs.ruleFormName.resetFields();*/


			},
			hdsubmitForm(formName) {
				var hasmoney = 0,
					hasbank = 0,
					haszhanghao = 0
				for (var i = 0; i < this.hdruleForm.add2.length; i++) {
					if (this.hdruleForm.add2[i].zhanghao == "") {
						haszhanghao = 1
					}
					if (this.hdruleForm.add2[i].money == "") {
						hasmoney = 1
					}
					if (this.hdruleForm.add2[i].bank == "") {
						hasbank = 1
					}
					//delete this.ruleForm.add2[i].xh
				}
				if (hasbank == 1) {
					this.$message({
						message: '请选择开户银行',
						type: 'error'
					});
					return
				}
				if (hasmoney == 1) {
					this.$message({
						message: '请填写金额',
						type: 'error'
					});
					return
				}
				if (haszhanghao == 1) {
					this.$message({
						message: '请填写打款账号',
						type: 'error'
					});
					return
				}
				if (this.hdruleForm.add2.length == 0) {
					this.$message({
						message: '请至少填写一行付款单',
						type: 'error'
					});
					return
				}
				if (!!this.hddanjuhao) {
					request({
						url: '/DRPAPI.ashx?a=gethdfukuanbjsave',
						method: 'post',
						contentType: "application/json; charset=utf-8",
						dataType: "json",
						data: {
							q: JSON.stringify({
								beizhu: this.hdruleForm.add.txtbeizhu,
								Ddata: this.hdruleForm.add2,
								User: this.$store.state.user.F_CustomerId,
								kemu: this.hdruleForm.add.txtkemu,
								danjuhao: this.hddanjuhao,
			
							})
						}
					}).then(res => {
						this.$message({
							message: '保存成功',
							type: 'success'
						});
						this.hdgetList();
						//this.ruleForm.add2 = []
						//this.addDialog = false
					})
				} else {
					request({
						url: '/DRPAPI.ashx?a=gethdfukuansave',
						method: 'post',
						contentType: "application/json; charset=utf-8",
						dataType: "json",
						data: {
							q: JSON.stringify({
								beizhu: this.hdruleForm.add.txtbeizhu,
								Ddata: this.hdruleForm.add2,
								User: this.$store.state.user.F_CustomerId,
								kemu: this.hdruleForm.add.txtkemu,
			
							})
						}
					}).then(res => {
						this.$message({
							message: '保存成功',
							type: 'success'
						});
						this.hdgetList();
						//this.ruleForm.add2 = []
						this.hdaddDialog = false
					})
				}
			
				/*this.$refs.ruleFormName.resetFields();*/
			
			
			},
			quxiao() {
				this.disabled = true
				this.ruleForm.add.Ccaozuotype = '查看'
				
			},
			xiugai() {
				this.disabled = false
				this.ruleForm.add.Ccaozuotype = '编辑'
			},
			hdquxiao() {
				this.disabled = true
				this.hdruleForm.add.Ccaozuotype = '查看'
				
			},
			hdxiugai() {
				this.disabled = false
				this.hdruleForm.add.Ccaozuotype = '编辑'
			},
			//addDialog表格删除按钮
			handleDeleteDetails(row, $index) {
				this.ruleForm.add2.splice(row.xh - 1, 1);
			},
			hdhandleDeleteDetails(row, $index) {
				this.hdruleForm.add2.splice(row.xh - 1, 1);
			},
			//addDialog表格新增按钮
			handleAddDetails() {
				if (this.ruleForm.add2 == undefined) {
					this.ruleForm.add2 = new Array();
				}
				let obj = {};
				obj.yongtu = "";
				obj.money = "";
				obj.bank = "";
				obj.huming = "";
				obj.zhanghao = "";
				obj.fujian = "";

				this.ruleForm.add2.push(obj);
			},
			hdhandleAddDetails() {
				if (this.hdruleForm.add2 == undefined) {
					this.hdruleForm.add2 = new Array();
				}
				let obj = {};
				obj.yongtu = "";
				obj.money = "";
				obj.bank = "";
				obj.huming = "";
				obj.zhanghao = "";
				obj.fujian = "";
			
				this.hdruleForm.add2.push(obj);
			},
			//addDialog表格序号
			rowClassName({
				row,
				rowIndex
			}) {
				row.xh = rowIndex + 1;

			},
			hdrowClassName({
				row,
				rowIndex
			}) {
				row.xh = rowIndex + 1;
			
			},
			panduan(){
				if(this.ishd){
					this.$confirm('如参加5.8-5.20集采回款请至活动付款单提交付款单,请选择?', '提示', {
						confirmButtonText: '集采活动付款单',
						cancelButtonText: '普通付款单',
						type: 'warning'
					}).then(() => {
						this.activeName='hd';
						this.hdadd();
					}).catch(() => {
						this.add();
						
					});
				}else{
					this.add();
				}
				
				
			},
			//点击添加收款单
			
			add() {
				this.danjuhao=''
				//表单头部信息
				request({
					url: '/DRPAPI.ashx?a=getfukuantop',
					method: 'get',

				}).then(res => {
					this.ruleForm.add = res.data
				})
				//银行信息
				request({
					url: '/DRPAPI.ashx?a=getfukuanbank',
					method: 'get',

				}).then(res => {
					this.options2 = res.data.list
				})
				this.ruleForm.add2 = [];
				this.disabled = false;
				this.ruleForm.Cdata = new Date();
				this.addDialog = true;
			},
			hdadd() {
				this.hddanjuhao=''
				//表单头部信息
				request({
					url: '/DRPAPI.ashx?a=gethdfukuantop',
					method: 'get',
			
				}).then(res => {
					this.hdruleForm.add = res.data
				})
				//银行信息
				request({
					url: '/DRPAPI.ashx?a=gethdfukuanbank',
					method: 'get',
			
				}).then(res => {
					this.hdoptions2 = res.data.list
				})
				this.hdruleForm.add2 = [];
				this.disabled = false;
				this.hdruleForm.Cdata = new Date();
				this.hdaddDialog = true;
			},
			//选择银行
			back(row) {
				for (var i = 0; i < this.options2.length; i++) {
					if (row.bank == this.options2[i].bank) {
						row.huming = this.options2[i].huming
						row.zhanghao = this.options2[i].zhanghao
					}
				}
			},
			hdback(row) {
				for (var i = 0; i < this.hdoptions2.length; i++) {
					if (row.bank == this.hdoptions2[i].bank) {
						row.huming = this.hdoptions2[i].huming
						row.zhanghao = this.hdoptions2[i].zhanghao
					}
				}
			},
			//StateSelect状态搜索
			StateSelect() {
				this.queryJson.StepType = this.value;
				this.getList(this.queryJson)
			},
			hdStateSelect() {
				this.hdqueryJson.StepType = this.hdvalue;
				this.hdgetList(this.hdqueryJson)
			},
			//时间搜索
			select(e) {
				// console.log(e[0].getFullYear())
				// console.log(this.dateFormat(e[0]))
				this.queryJson.begindate = e[0];
				this.queryJson.enddate = e[1];
				this.getList(this.queryJson)
			},
			hdselect(e) {
				// console.log(e[0].getFullYear())
				// console.log(this.dateFormat(e[0]))
				this.hdqueryJson.begindate = e[0];
				this.hdqueryJson.enddate = e[1];
				this.hdgetList(this.hdqueryJson)
			},
			//查看按钮
			look(row) {
				this.disabled = true
				//表单头部信息
				request({
					url: '/DRPAPI.ashx?a=getfukuantop',
					method: 'get',
					data: {
						danjuhao: row.BillsNumber
					}
				}).then(res => {
					this.ruleForm.add = res.data
					this.ruleForm.Cdata = res.data.Cdata
					this.danjuhao = res.data.Ccode
					this.ruleForm.add.Ccaozuotype = '查看'
				})
				//中间表格信息
				request({
					url: '/DRPAPI.ashx?a=getfukuanlist',
					method: 'get',
					data: {
						danjuhao: row.BillsNumber
					}
				}).then(res => {
					this.ruleForm.add2 = res.data.list
				})
				this.addDialog = true;
			},
			hdlook(row) {
				this.disabled = true
				//表单头部信息
				request({
					url: '/DRPAPI.ashx?a=gethdfukuantop',
					method: 'get',
					data: {
						danjuhao: row.BillsNumber
					}
				}).then(res => {
					this.hdruleForm.add = res.data
					this.hdruleForm.Cdata = res.data.Cdata
					this.hddanjuhao = res.data.Ccode
					this.hdruleForm.add.Ccaozuotype = '查看'
				})
				//中间表格信息
				request({
					url: '/DRPAPI.ashx?a=gethdfukuanlist',
					method: 'get',
					data: {
						danjuhao: row.BillsNumber
					}
				}).then(res => {
					this.hdruleForm.add2 = res.data.list
				})
				this.hdaddDialog = true;
			},
			//编辑按钮
			compile(row) {
				this.disabled = false
				//表单头部信息
				request({
					url: '/DRPAPI.ashx?a=getfukuantop',
					method: 'get',
					data: {
						danjuhao: row.BillsNumber
					}
				}).then(res => {
					this.ruleForm.add = res.data
					this.ruleForm.Cdata = res.data.Cdata
					this.danjuhao = res.data.Ccode
					this.ruleForm.add.Ccaozuotype = '编辑'
				})
				//中间表格信息
				request({
					url: '/DRPAPI.ashx?a=getfukuanlist',
					method: 'get',
					data: {
						danjuhao: row.BillsNumber
					}
				}).then(res => {
					this.ruleForm.add2 = res.data.list
				})
				this.addDialog = true;
			},
			hdcompile(row) {
				this.disabled = false
				//表单头部信息
				request({
					url: '/DRPAPI.ashx?a=gethdfukuantop',
					method: 'get',
					data: {
						danjuhao: row.BillsNumber
					}
				}).then(res => {
					this.hdruleForm.add = res.data
					this.hdruleForm.Cdata = res.data.Cdata
					this.hddanjuhao = res.data.Ccode
					this.hdruleForm.add.Ccaozuotype = '编辑'
				})
				//中间表格信息
				request({
					url: '/DRPAPI.ashx?a=gethdfukuanlist',
					method: 'get',
					data: {
						danjuhao: row.BillsNumber
					}
				}).then(res => {
					this.hdruleForm.add2 = res.data.list
				})
				this.hdaddDialog = true;
			},
			//删除按钮
			deleterow(row) {
				this.$confirm('确定删除？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					request({
						url: '/DRPAPI.ashx?a=getfukuandelete',
						method: 'post',
						data: {
							BillsNumber: row.BillsNumber,
							usercode: this.$store.state.user.F_CustomerId
						}
					}).then(res => {
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.getList();
					})
				})

			},
			hddeleterow(row) {
				this.$confirm('确定删除？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					request({
						url: '/DRPAPI.ashx?a=gethdfukuandelete',
						method: 'post',
						data: {
							BillsNumber: row.BillsNumber,
							usercode: this.$store.state.user.F_CustomerId
						}
					}).then(res => {
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.hdgetList();
					})
				})
			
			},
			// dateFormat(date) {
			// 	let year = date.getFullYear();
			// 	let month = date.getMonth() + 1;
			// 	if (month < 10) {
			// 		month = `0${month}`
			// 	}
			// 	let day = date.getDate();
			// 	if (day < 10) {
			// 		day = `0${day}`
			// 	}
			// 	return `${year}-${month}-${day}`
			// },
			//表格全部数据
			getList(keyword) {
				this.loading=true
				request({
					url: '/DRPAPI.ashx?a=getfukuanlists',
					method: 'get',
					data: {
						pagination: JSON.stringify(this.pagination),

						queryJson: JSON.stringify(this.queryJson)
					}
				}).then(res => {
					this.loading = false
					this.pagination.page = res.data.page
					this.pagination.records = res.data.records
					this.pagination.total = res.data.total
					this.tableData = res.data.rows
					this.records = res.data.records
					var sum = 0
					for (var i = 0; i < res.data.rows.length; i++) {
						sum += res.data.rows[i].F_OrderAmount
						// console.log(sum)
					}
					this.sum = sum
					// this.pagination.page = res.data.page
					// this.pagination.records = res.data.records
					// this.pagination.total = res.data.total
				})

			},
			hdgetList(keyword) {
				this.hdloading=true
				request({
					url: '/DRPAPI.ashx?a=gethdfukuanlists',
					method: 'get',
					data: {
						pagination: JSON.stringify(this.hdpagination),

						queryJson: JSON.stringify(this.hdqueryJson)
					}
				}).then(res => {
					this.hdloading = false
					this.hdpagination.page = res.data.page
					this.hdpagination.records = res.data.records
					this.hdpagination.total = res.data.total
					this.hdtableData = res.data.rows
					this.hdrecords = res.data.records
					var sum = 0
					for (var i = 0; i < res.data.rows.length; i++) {
						sum += res.data.rows[i].F_OrderAmount
						// console.log(sum)
					}
					this.hdsum = sum
					// this.pagination.page = res.data.page
					// this.pagination.records = res.data.records
					// this.pagination.total = res.data.total
				})

			},
			//已作废
			cancel(value) {
				if (value === "全部") {
					this.keyword.F_Invalid = "",
						this.keyword.F_FlowCode = "",
						this.getList(this.keyword)
				} else if (value === "已作废") {
					this.keyword.F_Invalid = 1,
						this.keyword.F_FlowCode = "",
						this.getList(this.keyword)
				} else if (value === "待支付") {
					this.keyword.F_Invalid = 0,
						this.keyword.F_FlowCode = 'generate',
						this.getList(this.keyword)
				} else if (value === "待审核") {
					this.keyword.F_Invalid = "",
						this.keyword.F_FlowCode = 'payed',
						this.getList(this.keyword)
				}

			},
			hdcancel(value) {
				if (value === "全部") {
					this.hdkeyword.F_Invalid = "",
						this.hdkeyword.F_FlowCode = "",
						this.hdgetList(this.hdkeyword)
				} else if (value === "已作废") {
					this.hdkeyword.F_Invalid = 1,
						this.hdkeyword.F_FlowCode = "",
						this.hdgetList(this.hdkeyword)
				} else if (value === "待支付") {
					this.hdkeyword.F_Invalid = 0,
						this.hdkeyword.F_FlowCode = 'generate',
						this.hdgetList(this.hdkeyword)
				} else if (value === "待审核") {
					this.hdkeyword.F_Invalid = "",
						this.hdkeyword.F_FlowCode = 'payed',
						this.hdgetList(this.hdkeyword)
				}
			
			},
			//导出按钮
			exportExcel: function(outTable) {
				var reportTitle = Date.parse(new Date()) + '.xlsx'
				/* generate workbook object from table */
				// 判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去，
				var fix = document.querySelector('.el-table__fixed-right');
				var wb;
				var xlsxParam = {
					raw: true
				}; //转换成excel时，使用原始的格式
				if (fix) {
					wb = XLSX.utils.table_to_book(document.querySelector('#outTable').removeChild(fix), xlsxParam);
					document.querySelector('#outTable').appendChild(fix);
				} else {
					wb = XLSX.utils.table_to_book(document.querySelector('#outTable'), xlsxParam);
				}
				/* get binary string as output */
				var wbout = XLSX.writeFile(wb, '付款单数据.xlsx');
				/*try {
				  FileSaver.saveAs(
				      new Blob([wbout], {
				        type: 'application/octet-stream'
				      }),
				      reportTitle
				  );
				} catch (e) {
				  if (typeof console !== 'undefined') console.log(e, wbout);
				}*/
				return wbout;
			},
			hdexportExcel: function(outTable) {
				var reportTitle = Date.parse(new Date()) + '.xlsx'
				/* generate workbook object from table */
				// 判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去，
				var fix = document.querySelector('.el-table__fixed-right');
				var wb;
				var xlsxParam = {
					raw: true
				}; //转换成excel时，使用原始的格式
				if (fix) {
					wb = XLSX.utils.table_to_book(document.querySelector('#hdoutTable').removeChild(fix), xlsxParam);
					document.querySelector('#hdoutTable').appendChild(fix);
				} else {
					wb = XLSX.utils.table_to_book(document.querySelector('#hdoutTable'), xlsxParam);
				}
				/* get binary string as output */
				var wbout = XLSX.writeFile(wb, '活动付款单数据.xlsx');
				/*try {
				  FileSaver.saveAs(
				      new Blob([wbout], {
				        type: 'application/octet-stream'
				      }),
				      reportTitle
				  );
				} catch (e) {
				  if (typeof console !== 'undefined') console.log(e, wbout);
				}*/
				return wbout;
			},

			handleSizeChange(newSize) {
				this.pagination.rows = newSize;
				this.getList(this.keyword);
			},
			handleCurrentChange(newPage) {
				this.pagination.page = newPage;
				this.getList(this.keyword);
			},
			indexMethod(index) {
				return index * 1 + 1;
			},
			hdhandleSizeChange(newSize) {
				this.hdpagination.rows = newSize;
				this.hdgetList(this.hdkeyword);
			},
			hdhandleCurrentChange(newPage) {
				this.hdpagination.page = newPage;
				this.hdgetList(this.hdkeyword);
			},
			hdindexMethod(index) {
				return index * 1 + 1;
			}
		}
	};
</script>

<style>
	.pay-status,
	.order-time {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}

	.elbutton {
		display: flex;
		flex-wrap: wrap;
	}

	.el-breadcrumb {
		font-size: 12px;
		line-height: 1;
		margin-top: 5px;
	}

	.el-button--mini {
		padding: 5px 10px !important;
	}
	.el-table .cell{
		line-height: 2 !important;
	}
	.dialog-footer{
		display: flex;
		justify-content: flex-end;
	}
</style>
